import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
// import MessengerCustomerChat from 'react-messenger-customer-chat';
import FingotiNav from '@fingoti/nav';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';

import { useProfileState } from '../context/ProfileContext';
import { apiService } from '../services/api.service';
import * as appConfig from '../services/config';

const useStyles = makeStyles(theme => ({

    root: {
        maxWidth: '100%',
        padding: theme.spacing(1),
        margin: 0,
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(100% - 114px);',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: theme.spacing(3),
        }
    },

}))

const Layout = ({ children }) => {

    const history = useHistory();
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();

    const handleSideNavClick = (link) => {
        history.push(link);
    }

    const handleBackClick = () => {
        history.goBack();
    }

    const handleSwitchOrganisation = () => {
        // TODO: re-enable once org switching is migrated to the new auth flow
        enqueueSnackbar("Organisation switching is temporarily disabled", { variant: 'info' });
    }

    const handleLogout = () => {
        history.push('/logout');
    }

    return (
        <React.Fragment>
            <FingotiNav
                onSideNavClick={handleSideNavClick}
                onBackClick={handleBackClick}
                currentApp="account"
                useProfileState={useProfileState}
                handleSwitchOrganisation={handleSwitchOrganisation}
                apiService={apiService}
                handleLogout={handleLogout}
                config={appConfig}
            />
            <Container className={classes.root}>
                {children}
            </Container>
            {/* {isDesktop &&
                <MessengerCustomerChat
                    pageId="215950192435406"
                    htmlRef={window.location.pathname}
                />
            } */}
        </React.Fragment>
    );
}

export default Layout;
